import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router";
import { CartContext } from "../cart/ContextProvider";
import './orderSuccess.css';

function OrderSuccess() {

    const { setInitialLoading, setOrderSuccess,  } = useContext(CartContext)

    const navigate = useNavigate();



    function handleClick() {


        navigate('/cart');
        setOrderSuccess(false)

    }




    return (
        <div className="success-page">
            <h2>Success!</h2>
            <p>Your order has been placed successfully. Thank you!</p>
            <p className="orderSuccessButton" onClick={handleClick}>Go to Orders</p>

            {/* You can include additional content for the success page */}
        </div>
    )
}

export default OrderSuccess;